<template>

    <el-date-picker 
        v-model="time" 
        :type="pickerType" 
        :value-format="valueformat" 
        @change="timeChange"
        format="yyyy - MM - dd "
        range-separator="至" 
        start-placeholder="开始日期" 
        end-placeholder="结束日期"
        size="small"
		:clearable="clearable"
        >
    </el-date-picker>

    


</template>
<script>
    export default {
      props:{
        
        catename:{type:String,default:null},
        value:{
            type:String,default:null
        },
        valueformat:{type:String,default:'timestamp'},
        // daterange datetimerange
        pickerType:{type:String,default:'daterange'},
        timeList:{type:Array,default:()=>[]},
        startTime:{type:[String,Number],default:'null'},
        endTime:{type:[String,Number],default:'null'},
        clearable:{type:Boolean,default:true}
      },
      watch:{
      timeList(){
          this.time= this.timeList
        }
   },
        data() {
          return {
            time:[]
          };
        },
        methods: {
            timeChange(data){
              console.log('timeChange',data)
                let list = []
                if(data&&data.length&&data[0]){
                    data.forEach((element,index) => {
                     if(index==0){
                      list.push(element/1000)
                     }else{
                      list.push(element/1000+86399)
                     }
                       
                    });
                }
               
                this.$emit('click',list,this.catename)
            },
            clearData(){
              this.time= []
            },
        },
        created() {
            
          if(this.value){
            this.value.split(",").forEach(element => {
                this.time.push(element*1000)
            });
            
          }
          if(this.startTime&&this.endTime){
          this.time = [this.startTime*1000,this.endTime*1000]
        }
        },
      }
    </script>
    
    <style >
      .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner{
        width: 280px !important;
        font-size: 10px !important;
      }
    </style>